import React from "react";

const DatePicker = ({ selectedDate, onDateChange }) => {
  const dates = [];
  const today = new Date();

  // Generate dates for the next 7 days
  for (let i = 0; i < 7; i++) {
    const date = new Date();
    date.setDate(today.getDate() + i);
    dates.push(date);
  }

  // Get day names in short format (S M T W T F S)
  const getDayName = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "narrow" });
  };

  return (
    <div className="flex flex-col gap-1">
      {/* Day names row */}
      <div className="flex items-center gap-2">
        {dates.map((date) => (
          <div
            key={`day-${date.toISOString()}`}
            className="w-7 h-7 flex items-center justify-center text-xs text-gray-400"
          >
            {getDayName(date)}
          </div>
        ))}
      </div>

      {/* Dates row */}
      <div className="flex items-center gap-2">
        {dates.map((date) => {
          const isSelected =
            date.toDateString() === selectedDate.toDateString();

          return (
            <button
              key={date.toISOString()}
              onClick={() => onDateChange(date)}
              className={`
                w-7 h-7 flex items-center justify-center rounded-full text-sm
                ${
                  isSelected
                    ? " bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-black"
                    : "text-gray-400"
                }
                ${!isSelected && "hover:bg-gray-100"}
              `}
            >
              {date.getDate()}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DatePicker;
